import {Component, h, Prop} from '@stencil/core';

/** @slot panel-title - Title of the panel. Mandatory
 *   @slot panel-title-action - CTA in top right corner. Not mandatory
 *   @slot panel-subtitle - Subtitle of the panel. Not mandatory
 *   @slot panel-body - All the content you need in your panel. Insert what you want here
 *   @slot panel-action - If you need a CTA, use this. You can call it as many times as you need
 *   */

@Component({
    tag: 'joy-template',
    styleUrl: 'template.scss',
    shadow: true,
})
export class JoyTemplate {
    /** Use all available width, or reduce the layout to 1024px width **/
    @Prop({reflect: true}) full = false;
    /** Sidebar position **/
    @Prop({reflect: true}) sidebar: 'left' | 'right' = 'right';

    render() {
        return (
            <main
                class={{
                    'joy-layout': true,
                    'joy-layout--full': this.full,
                }}
            >
                <div class="joy-layout__heading">
                    <slot name="template-back" />
                    <div class="joy-layout__heading__headings">
                        <slot name="template-title" />
                        <slot name="template-subtitle" />
                    </div>
                    <slot name="template-actions" />
                </div>

                <div
                    class={{
                        'joy-layout__content': true,
                        'joy-layout__content--reverse': this.sidebar === 'left',
                    }}
                >
                    <slot name="template-main" />
                    <slot name="template-sidebar" />
                </div>
            </main>
        );
    }
}
